import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_elavon_event.js";
//#region src/bite_log_elavon_event_helper.ts
var bite_log_elavon_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 0: return "ok";
		case 1: return "terminal-disconnected";
		case 5: return "terminal-connected";
		case 2: return "update-idle-text-error";
		case 3: return "transaction-sale";
		case 4: return "transaction-sale-error";
		case 6: return "no-response-received";
		case 7: return "transaction-inquiry";
		case 8: return "transaction-inquiry-error";
		case 9: return "transaction-cancel";
		case 10: return "transaction-cancel-error";
		case 11: return "get-or-save-reference-sequence-failed";
		case 12: return "opt-connect-failure";
	}
}
//#endregion
export { bite_log_elavon_event_helper_exports, name };

//# sourceMappingURL=bite_log_elavon_event_helper.js.map